/** Pick workplace / educator / community / parent content pack by study module id. */
export function pickFlowModule(moduleId, workplace, educator, community, parent) {
  if (moduleId === 'community-module') return community;
  if (moduleId === 'educator-module') return educator;
  if (moduleId === 'parent-module' && parent !== undefined) return parent;
  return workplace;
}

export function isFiveBarrierModuleId(moduleId) {
  return moduleId === 'educator-module' || moduleId === 'community-module';
}

export function isParentModuleId(moduleId) {
  return moduleId === 'parent-module';
}
